import React from 'react';
import PropTypes from 'prop-types';

/**
 * TimelineYearMarker - Year pill on the timeline
 */
function TimelineYearMarker({ year }) {
  return (
    <div className="flex items-center gap-3 py-2">
      <div
        className="
          bg-fb-olive text-white
          px-4 py-1 rounded-full
          font-sans text-sm font-bold
        "
      >
        {year}
      </div>
      <div className="flex-1 h-px bg-gray-200" />
    </div>
  );
}

TimelineYearMarker.propTypes = {
  year: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default TimelineYearMarker;
